import React, { Component } from "react";
import { history } from "../../app/AppRouter";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import AddDropdown from "./AddDropdown";
import Button from "../../components/buttons/primaryButton";
import navigationconfig from "../../contents/trainerIcons";
import {
  logout,
  createClass,
  getPackages,
  getGym
} from "../../redux/actions/api/apiAction";
import { store } from "../../redux/storeConfig/store";
import {
  Modal,
  ModalBody} from "reactstrap";
import {
  setSidebarStatus,
  addTrainerModal,
  addUserModal,
  addPrivateModal,
  addWodModal,
  setAlertModal,
  addPackageModal,
  addSaleModal
} from "../../redux/actions/sidebar/sidebarAction";
import "react-datepicker/dist/react-datepicker.css";
import { ComonIcons } from "../../contents/commonIcons";
import MultiStep from "../trainer/trainerForm";
import MultiStepForPackage from "../package/packageForm";
import MultiStepForSale from "../sale/saleForm";
import MultiStepForMember from "../member/memberForm";
// import MemberForm from '../member/memberForm';
// import MultiStepForMember from "../trainerComponents/member/memberForm";

import ClassForm from "../class/class";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { AddProgramModal } from "../addProgramModal";

const getUTCDateTime = (newdate, time) => {
  let date = moment(newdate).format("MM/DD/YYYY");
  let hour = new Date(`${date} ${time}`).getUTCHours();
  let min = new Date(`${date} ${time}`).getUTCMinutes();
  let dateUTC = new Date(`${date} ${time}`).getUTCDate();
  let monthUTC = new Date(`${date} ${time}`).getUTCMonth();
  let yearUTC = new Date(`${date} ${time}`).getUTCFullYear();
  let newTime = new Date(`${monthUTC + 1}/${dateUTC}/${yearUTC} UTC`).getTime();

  return {
    date: newTime,
    time: `${hour}:${min}:00`,
    newDate: `${monthUTC + 1}/${dateUTC}/${yearUTC}`
  };
};

const getLocalDateTime = (newdate, time) => {
  let date = moment(newdate).format("MM/DD/YYYY");
  let hour = new Date(`${date} ${time} UTC`).getHours();
  let min = new Date(`${date} ${time} UTC`).getMinutes();
  let dateUTC = new Date(`${date} ${time} UTC`).getDate();
  let monthUTC = new Date(`${date} ${time} UTC`).getMonth();
  let yearUTC = new Date(`${date} ${time} UTC`).getFullYear();
  let newTime = new Date(`${monthUTC + 1}/${dateUTC}/${yearUTC} UTC`).getTime();

  return {
    date: newTime,
    time: `${hour}:${min}:00`,
    newDate: `${monthUTC + 1}/${dateUTC}/${yearUTC}`
  };
};


const Week = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat"
};

const FindDatesOfClass = (startDate, endDate, repeatDays) => {
  let response = [];
  let local = moment(startDate).format("MM/DD/YYYY");
  let local2 = moment(endDate).format("MM/DD/YYYY");
  let start = new Date(`${local} UTC`);
  let end = new Date(`${local2} UTC`);
  // const start = new Date(startDate);
  // const end = new Date(endDate);
  let loop = start;
  while (loop <= end) {
    if (repeatDays.includes(Week[loop.getDay()])) {
      response.push(loop.getTime());
    }
    let newDate = loop.setDate(loop.getDate() + 1);
    loop = new Date(newDate);
  }
  return response;
};

const getNewUTCTimes = (dates, time) => {
  let newArray = [];
  dates.map(one => {
    let data = getUTCDateTime(one, time).date;
    newArray.push(data);
  });
  return newArray;
};
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      packages: []
    };
  }
  state = {
    sidebarOpen: false,
    addModal: false
  };

  sidebarToggle() {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen
    });
  }
  addTrainer = async () => {
    this.props.addTrainerModal(!this.props.trainerModal);
  };
  // addUser = async () => {
  //   this.props.addUserModal(!this.props.userModal);
  // };
  addPrivate = async () => {
    //console.log("133131313");
    this.props.addPrivateModal(!this.props.privateModal);
  };
  addWod = async () => {
    //console.log("hello ");
    this.props.addWodModal(!this.props.wodModal);
  };
  componentDidMount() {
    if(this.props.trainer.gym){
     store.dispatch(getGym(this.props.trainer.gym));
    }
  }
  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  handleSubmit = async values => {
    let daysArray = values.day.map((one) => {
      return one.slice(0, 3).toLowerCase();
    });
    // //console.log("here", values);
    let data = {
      canLive: values.canLive,
      name: values.name,
      trainer: values.trainer,
      capacity: values.capacity,
      waitingList: values.waitingList,
      price: values.price,
      location: values.location,
      type: values.type,
      repeatDays: daysArray.join(","),
      startDate: values.startDate,
      endDate: values.endDate,
      from: getUTCDateTime(values.startDate, values.from).time,
      to: getUTCDateTime(values.endDate, values.to).time,
      members: values.members || [],
      image: values.type !== "OFFLINE" ? values.image : ""
    };
    //console.log("Data",data);
    let check = FindDatesOfClass(data.startDate, data.endDate, data.repeatDays);
    //console.log("Check", check);
    if (check.length > 0) {
      // data.classDates=check;
      data.classDates = getNewUTCTimes(
        check,
        getLocalDateTime(data.startDate, data.from).time
      );
      await store.dispatch(createClass(data));
      // console.log("last Data", data);
    } else toastr.error("No selected day found in selected date range");
  };

  alertModal = () => {
    this.props.setAlertModal(!this.props.alertModal);
  };

  goToInfo = () => {
    this.alertModal();
    if (
      this.props.loginUser.role === "GYM" ||
      this.props.loginUser.role === "STAFF"
    )
      history.push("/gym-panel/gyminfoedit");
    else history.push("/trainer-panel/trainerinfo/edit");
  };
  render() {
    let userData = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    let LoggedInRole =
      this.props.trainer.gym && this.props.trainer.id ? "GT" : "PT";
    return (
      <div className={this.props.sidebarStatus ? "sidebar active" : "sidebar"}>
        <nav id="sidebar" className="sidebar-wrapper">
          <div className="sidebar-main-block ">
            <div className="user-main-block position-relative">
              <div className="user-img-block">
                <img
                  src={
                    this.props.trainer.user && this.props.trainer.user.image
                      ? this.props.trainer.user.image
                      : require("../../assets/images/no-image_user.jpg")
                  }
                  className="img-fluid"
                />
              </div>
              <div className="username">
                <h4 className="f-bold mb-0 overflow-auto">
                  {this.props.trainer.user && this.props.trainer.user.name}
                </h4>
              </div>
              <div
                className="close-icon-sidebar"
                onClick={() => {
                  this.props.setSidebarStatus(!this.props.sidebarStatus);
                }}
              >
                {ComonIcons.close}
              </div>
            </div>
            <div className="seperator"></div>
          </div>
          <div className="sidebar-dropdown">
            <AddDropdown
              addPrivateModal={this.addPrivate}
              LoggedInRole={LoggedInRole}
              setPackages={i => this.setState({ packages: i })}
            />
          </div>
          <div className="pages-main-link-block">
            <div className="list-ul">
              <ul className="list-main-block">
                {/* <li className="list-element list-dropdown" > */}
                {navigationconfig.map((value) => {
                  if (LoggedInRole && value.role.includes(LoggedInRole))
                    return (
                      <li
                        className={`list-element ${
                          history.location.pathname.includes(value.navLink)
                            ? "active"
                            : " "
                        }`}
                        key={value.id}
                      >
                        <div className="curve">
                          <div className="list-element-upper-curve"></div>
                        </div>
                        <NavLink exact to={value.navLink} className="link-blk">
                          <div className="link-data">
                            <div className="link-img">{value.icon}</div>
                            <div className="link-text">{value.title}</div>
                          </div>
                        </NavLink>
                        <div className="curve-2">
                          <div className="list-element-upper-curve-2"></div>
                        </div>
                      </li>
                    );
                })}
              </ul>
            </div>
          </div>
        </nav>
        <div className="side-bar-footer">
          <div className="out-block">
            <Link
              to="/"
              className="link-main-block"
              onClick={() => store.dispatch(logout(userData.id))}
            >
              <div className="link-data">
                <div className="d-flex align-items-center">
                  <div className="link-img">{ComonIcons.signout}</div>
                  <div className="content">Sign Out</div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* adding Trainer pop up  for use it   */}
        <Modal
          isOpen={this.props.trainerModal}
          toggle={() => {
            this.props.addTrainerModal(!this.props.trainerModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup"
        >
          <MultiStep handleSubmit={this.createTrainer} />
        </Modal>
        {/* adding user/member pop up  for use it   */}
        <Modal
          isOpen={this.props.userModal}
          toggle={() => {
            this.props.addUserModal(!this.props.userModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          {/*For Member*/}
          <MultiStepForMember packages={this.state.packages} />
        </Modal>
        {/**For Add class */}
        <Modal
          isOpen={this.props.privateModal}
          toggle={() => {
            this.addPrivate();
          }}
          centered={true}
          size="xl"
          className="large-pop"
        >
          <ClassForm
            handleSubmit={this.handleSubmit}
            showTrainer={false}
            trainer={
              JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                .trainer
            }
            addPrivate={this.addPrivate}
            canLive={this.props.trainer.canLive}
          />
        </Modal>
        <Modal
          isOpen={this.props.packageModal}
          toggle={() => {
            this.props.addPackageModal(!this.props.packageModal, false, {});
          }}
          centered={true}
          size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <MultiStepForPackage />
        </Modal>
        <Modal
          isOpen={this.props.saleModal}
          toggle={() => {
            this.props.addSaleModal(!this.props.saleModal, false, {});
          }}
          centered={true}
          size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <MultiStepForSale members={this.props.allMembers} />
        </Modal>

        <AddProgramModal />

        <Modal
          isOpen={this.props.alertModal}
          toggle={this.alertModal}
          centered={true}
          className="small-pop delete-pop"
        >
          <ModalBody>
            <div className="modal-body-content">
              <div className="content">
                <div className="delete-title">
                  <h4 className="f-bold">Important Info</h4>
                </div>
                <div className="delete-data">
                  <h5>
                    Please complete your profile to appear on website.
                    <br />
                    {"if done, ignore this message"}
                  </h5>
                </div>
              </div>
              <div className="action-btn-block">
                <Button
                  type="button"
                  value="Cancel"
                  styleClass="btn-small btn-danger"
                  onClick={this.alertModal}
                />
                <Button
                  type="button"
                  // toggle={this.toggle}
                  value="Add Info"
                  styleClass="btn-small"
                  onClick={() => this.goToInfo()}
                />
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log("State in sidebar", state);
  const {
    sidebarStatus,
    trainerModal,
    userModal,
    privateModal,
    wodModal,
    alertModal,
    packageModal,
    saleModal,
    staffModal
  } = state.sidebar;
  const { trainer } = state.trainer;
  const { loginUser } = state.login;
  const { packages } = state.packages;
  return {
    packages,
    sidebarStatus,
    trainerModal,
    userModal,
    privateModal,
    wodModal,
    trainer,
    loginUser,
    alertModal,
    packageModal,
    saleModal,
    staffModal
  };
};
export default connect(mapStateToProps, {
  setSidebarStatus,
  addTrainerModal,
  addUserModal,
  addPrivateModal,
  addWodModal,
  setAlertModal,
  getPackages,
  addPackageModal,
  addSaleModal
})(Sidebar);

// export default Sidebar;
